import script from "./CheckoutProductReview.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckoutProductReview.vue?vue&type=script&setup=true&lang=js"

import "./CheckoutProductReview.vue?vue&type=style&index=0&id=3c342a6a&lang=css"

const __exports__ = script;

export default __exports__